import React, { useState } from 'react';

import { CmModal } from '@/components/uiParts';
import useMenuManagementBulkUpsertBrandItems from '@/services/BrandItem/hooks/upload/useMenuManagementBulkUpsertBrandItems';
import useMenuManagementPreviewBulkUpsertBrandItems, {
  PreviewBulkUpsertBrandItemsResponse,
} from '@/services/BrandItem/hooks/upload/useMenuManagementPreviewBulkUpsertBrandItems';

import PreviewCsv from './PreviewCsv';
import UploadForm from './UploadForm';

type Props = {
  isOpen: boolean;
  associateBrandId: string;
  handleCloseModal: () => void;
  onImportBrandItems: () => void;
};

const CsvUploadBrandItemsModal: React.FC<Props> = ({
  isOpen,
  handleCloseModal,
  associateBrandId,
  onImportBrandItems,
}) => {
  const [csvFile, setCsvFile] = useState<undefined | File>();
  const [previewResponse, setPreviewResponse] = useState<
    undefined | PreviewBulkUpsertBrandItemsResponse
  >();
  const { preview: previewCSV, loading: loadingPreview } =
    useMenuManagementPreviewBulkUpsertBrandItems();
  const { upload: uploadCSV, loading: loadingUpload } =
    useMenuManagementBulkUpsertBrandItems();

  const onClose = () => {
    setCsvFile(undefined);
    setPreviewResponse(undefined);
    handleCloseModal();
  };

  const handleClickPreview = async () => {
    if (csvFile == undefined) return;

    const response = await previewCSV({ associateBrandId, file: csvFile });
    setPreviewResponse(response);
  };

  const handleClickImport = async () => {
    if (csvFile == undefined) return;

    await uploadCSV({ associateBrandId, file: csvFile });
    onImportBrandItems();
    onClose();
  };

  return (
    <CmModal size="5xl" title="CSVインポート" isOpen={isOpen} onClose={onClose}>
      {previewResponse ? (
        <PreviewCsv
          insertCount={previewResponse.insert_count}
          updateCount={previewResponse.update_count}
          errorsByLine={previewResponse.errors_by_line}
          brandItems={previewResponse.brand_items}
          isDisableImport={!csvFile}
          isLoadingImport={loadingUpload}
          handleClickImport={handleClickImport}
          handleClickCancel={onClose}
        />
      ) : (
        <UploadForm
          csvFile={csvFile}
          associateBrandId={associateBrandId}
          handleInputChange={setCsvFile}
          handleClickPreview={handleClickPreview}
          isPreviewLoading={loadingPreview}
        />
      )}
    </CmModal>
  );
};

export default CsvUploadBrandItemsModal;
